import React from 'react';
import { Card, BlockStack, Text, TextField, RadioButton, InlineStack } from '@shopify/polaris';

export function OrdersDiscountSection({ value, onChange, bare = false }) {
  const update = (field, newValue) => onChange({ ...value, [field]: newValue });

  const content = (
    <BlockStack gap="loose">
      <div>
        <Text variant="headingMd" fontWeight="bold" as="h3">Discount Settings</Text>
        <Text variant="bodyMd" color="subdued">Configure how order discounts are interpreted</Text>
      </div>

      <BlockStack gap="tight">
        <Text variant="bodyMd" fontWeight="medium">Discount Policy</Text>
        <BlockStack gap="loose">
          <RadioButton
            label="Track discounts on line items level"
            checked={value.discountPolicy === 'line'}
            onChange={() => update('discountPolicy', 'line')}
          />
          <RadioButton
            label="Apply discounts on order level"
            checked={value.discountPolicy === 'order'}
            onChange={() => update('discountPolicy', 'order')}
          />
        </BlockStack>
      </BlockStack>

      <TextField
        label="NetSuite discount item to track discounts"
        value={value.netSuiteDiscountItem || ''}
        onChange={(v) => update('netSuiteDiscountItem', v)}
        placeholder="Enter NetSuite discount item ID or name"
      />
    </BlockStack>
  );

  return bare ? content : (
    <Card sectioned>
      {content}
    </Card>
  );
}


